export default {
    // récuperer toutes les guichets dans la base de données 
    get_all_tarifications(serverParams){
        return axios.post('/tarification/list?page=' + serverParams.page, serverParams, {
            headers: {
                Authorization: "Bearer " + token
            }
        }) 
    },
    get_all_tarifications_by_grille(serverParams){
        return axios.post('/tarifications/grilletarifaire/' + serverParams.grilletarifaire_libelle + '?page=' + serverParams.page, serverParams, {
            headers: {
                Authorization: "Bearer " + token
            }
        }) 
    },
    // récuperer toutes les guichets dans la base de données 
    post_tarifications(tarification){
        return axios.post('/tarifications', tarification, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    // modifie l'entité dont le parametre est = id
    put_tarifications(id, tarification){
        return axios.post('/tarifications/' + id, tarification, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    // modifie l'entité dont le parametre est = id
    show_tarifications(id){
        return axios.get('/tarifications/'+id, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },
    // modifie l'entité dont le parametre est = id
    delete_tarifications(id){
        return axios.delete('/tarifications/'+id, {
            headers: {
                "Content-Type": 'application/json',
                "Authorization": "Bearer " + token
            }
        }) 
    },

}